/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actions and reducers used to manipulate application state
import { updateSSPStatus } from 'apps/sspadstxt/state/actions/sspmanagerstatus';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import SSPStatus from 'apps/sspadstxt/pages/sspmanager/sspdetail/sspstatus/sspstatus';


/* ========== ~~~~~~~~~~ SSP INFO: CHILD ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ sspAdsTxtState }) => {
    const { status } = sspAdsTxtState.sspManagerStatus.newSSPDetails;
    const { isEditMode, savingSSPDetails } = sspAdsTxtState.sspManagerStatus;
    return ({
        status,
        isEditMode,
        savingSSPDetails
    });
};

// map actions
const mapDispatchToProps = dispatch => ({
    updateSSPStatus: status => dispatch(updateSSPStatus(status))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SSPStatus);
